import { type FC } from 'react'
import { useFlags } from '@egw/feature-flags'
import { type FeatureFlags } from '@egw/constants'
import { AccountTypePageV1 } from './account-type-v1'
import { AccountTypePageV2 } from './account-type-v2'

/**
 * V1 - Old Account Types
 * V2 - New Account Types
 * Check LaunchDarkly flag description for account types in V2
 */
export const AccountTypePage: FC = () => {
  const { flags } = useFlags<FeatureFlags>()

  // Use the rolloutJointEnrollmentV2 feature flag to determine which page to show
  const isV2Enabled = flags.rolloutJointEnrollmentV2

  // If feature flag is enabled, show the v2 page, otherwise show the original page
  if (isV2Enabled) {
    return <AccountTypePageV2 />
  }

  return <AccountTypePageV1 />
}
